module.exports = __webpack_public_path__ + "static/img/light-green.546989f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light-green.png
// module id = ETZJ
// module chunks = 1